import { Table, Space, Button } from "antd";

import CustomLink from "@/components/ui/CustomLink";

import CheckIcon from "@/icons/CheckIcon";
import PencilIcon from "@/icons/PencilIcon";
import TrashIcon from "@/icons/TrashIcon";

const disableDelete = (item) => {
  if (!item) return true;
  if (
    (item.deleted && !item.can_be_deleted) ||
    (!item.can_be_deleted && !item.can_be_marked_deleted)
  )
    return true;
  return false;
};

// Таблица должностей
// Содержит список с возможностью сортировки
// Тут можно настроить колонки
const PositionsTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      width: 250,
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 1,
      },
      render: (_, item) => {
        return (
          <CustomLink onClick={() => onEditItem(item)}>{item.name}</CustomLink>
        );
      },
    },

    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Удалена",
      dataIndex: "deleted",
      key: "deleted",
      render: (deleted) =>
        deleted ? <CheckIcon style={{ fontSize: 16 }} /> : "",
    },

    {
      title: "",
      width: 90,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <Space>
          <Button
            type="link"
            icon={<PencilIcon />}
            onClick={() => onEditItem(item)}
          ></Button>
          <Button
            type="link"
            icon={<TrashIcon />}
            disabled={disableDelete(item)}
            onClick={() => onDeleteItem(item)}
          ></Button>
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default PositionsTable;
